import styled from "styled-components"

import {greys} from "@irati/ui/src/global/colors"

export const StyledSpan = styled.span`
  padding: 0 15px;
  border-right: 2px solid ${greys.light};

  &:last-child {
    border: none;
  }
`
